import { Camera } from "lucide-react";

const RORY_PHOTO = "/img/rory-start.jpg";

export const FounderPhoto = ({ className = "" }) => (
  <figure data-testid="founder-photo" className={`relative max-w-md ${className}`}>
    <div className="absolute -inset-3 rounded-[36px] bg-[#FF5A5F] rotate-[-3deg]" />
    <div className="relative rounded-[30px] overflow-hidden bg-white aspect-[4/5]">
      {RORY_PHOTO ? (
        <img src={RORY_PHOTO} alt="Rory Fox at 15 selling his first Swole Bears" className="h-full w-full object-cover object-top" />
      ) : (
        <div className="h-full w-full grid place-items-center text-center p-8 bg-[#FFF6EA]">
          <div>
            <Camera className="h-10 w-10 mx-auto text-[#4A4560]" />
            <p className="mt-3 font-display text-2xl">[Photo of Rory]</p>
            <p className="text-sm text-[#4A4560] mt-1">Founder photo goes here</p>
          </div>
        </div>
      )}
    </div>
    <figcaption className="absolute -bottom-4 right-4 rounded-full bg-[#1B1530] text-white text-sm font-bold px-5 py-2.5">Rory, 15 · The very first table</figcaption>
  </figure>
);
